import script from "./checkQr.vue?vue&type=script&setup=true&lang=js"
export * from "./checkQr.vue?vue&type=script&setup=true&lang=js"

import "./checkQr.vue?vue&type=style&index=0&id=5676e90e&lang=less"

const __exports__ = script;

export default __exports__